import { CarmViewService } from '../services/carm-view-service';
import { Color3DService } from '../services/color-3d-service';
import { CprAngleService } from '../services/cpr-angle-service';
import { CurrentLocationService } from '../services/current-location-service';
import { SizingStateService } from '../services/sizing/sizing-state-service';
import { WindowLevelService } from '../services/window-level-service';
import { ContrastTool } from '../tools/appearance/contrast-tool';
import { CarmRotateTool } from '../tools/camera/carm-rotate-tool';
import { PanTool } from '../tools/camera/pan-tool';
import { RotateTool } from '../tools/camera/rotate-tool';
import { VerticalRotateTool } from '../tools/camera/vertical-rotate-tool';
import { ZoomTool } from '../tools/camera/zoom-tool';
import { DistanceMeasurementTool } from '../tools/measurement/distance-tool';
import { CurrentLocationTool } from '../tools/selection/current-location-tool';
import { DiameterEditTool } from '../tools/sizing/diameter-edit-tool';
import { AngleScrollTool } from '../tools/slice/angle-scroll-tool';
import { SliceScrollTool } from '../tools/slice/slice-scroll-tool';
import { ToolRegistry } from '../tools/tool-registry';

let registered = false;

/**
 * Register all built-in tools in the global ToolRegistry.
 * Safe to call multiple times — only registers once.
 *
 */
export function registerDefaultTools(): void {
    if (registered) return;
    registered = true;

    ToolRegistry.register(PanTool.toolName, () => new PanTool());
    ToolRegistry.register(ZoomTool.toolName, () => new ZoomTool());
    ToolRegistry.register(RotateTool.toolName, () => new RotateTool());
    ToolRegistry.register(VerticalRotateTool.toolName, () => new VerticalRotateTool());
    ToolRegistry.register(DistanceMeasurementTool.toolName, () => new DistanceMeasurementTool());

    ToolRegistry.register(SliceScrollTool.toolName, () => new SliceScrollTool());

    ToolRegistry.register(
        CurrentLocationTool.toolName,
        (services) =>
            new CurrentLocationTool(
                services.getService<CurrentLocationService>(CurrentLocationService.SERVICE_NAME)
            )
    );

    ToolRegistry.register(
        DiameterEditTool.toolName,
        (services) =>
            new DiameterEditTool(services.getService<SizingStateService>(SizingStateService.SERVICE_NAME))
    );

    ToolRegistry.register(
        AngleScrollTool.toolName,
        (services) => new AngleScrollTool(services.getService<CprAngleService>(CprAngleService.SERVICE_NAME))
    );

    ToolRegistry.register(
        ContrastTool.toolName,
        (services) =>
            new ContrastTool(
                services.getService<WindowLevelService>(WindowLevelService.SERVICE_NAME),
                services.getService<Color3DService>(Color3DService.SERVICE_NAME)
            )
    );

    // Not part of any default binding — bound to left drag and the wheel by
    // CarmCameraBinding during C-arm edit mode only
    ToolRegistry.register(
        CarmRotateTool.toolName,
        (services) => new CarmRotateTool(services.getService<CarmViewService>(CarmViewService.SERVICE_NAME))
    );
}
